import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; 
import reportWebVitals from './reportWebVitals'; // Ensure this file exists and exports reportWebVitals
import ErrorBoundary from './components/ErrorBoundary'; // Import the ErrorBoundary
import { ThemeProvider } from './context/ThemeContext';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import i18n from './i18n'; // Import the i18n configuration
import { I18nextProvider } from 'react-i18next';
import SplashScreen from './components/SplashScreen';
import { AppProvider } from './AppContext'; // <-- IMPORT AppProvider
import { HelmetProvider } from 'react-helmet-async';


// Dynamically load Stripe.js from CDN
// This is essential for Stripe Checkout and Connect redirects.
const stripeScript = document.createElement('script');
stripeScript.src = "https://js.stripe.com/v3/";
document.head.appendChild(stripeScript);

if (!TimeAgo.getDefaultLocale()) {
  TimeAgo.addDefaultLocale(en);
}

// Register Firebase Messaging Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('Firebase Messaging Service Worker registered with scope:', registration.scope);
      }).catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Suspense fallback={<SplashScreen />}>
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <ErrorBoundary showDetails={true}>
          <ThemeProvider>
            <AppProvider>
                <App />
            </AppProvider>
          </ThemeProvider>
        </ErrorBoundary>
      </I18nextProvider>
    </HelmetProvider>
  </React.Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();